module.exports = __webpack_public_path__ + "static/media/manage5.291d6a61.jpg";